const SDK_VERSION = '8.31.0';

export { SDK_VERSION };
